const env = process.env.REACT_APP_DEPLOY_ENV;

const readEnv = (key, fallback) => process.env[key] || fallback;

const production = {
    // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
    // like '/berry-material-react/react/default'
    basename: '/',
    defaultPath: '/dashboard/default',
    fontFamily: `'Roboto', sans-serif`,
    borderRadius: 12,
    environment: readEnv('REACT_APP_ENVIRONMENT_LABEL', 'Producción'),
    baseResource: readEnv('REACT_APP_API_BASE_URL', 'https://api.rentascdmx.com'),
    authRedirectUri: readEnv('REACT_APP_AUTH_REDIRECT_URI', 'https://app.rentascdmx.com/'),
    companyName: readEnv('REACT_APP_COMPANY_NAME', 'Padilla&Bujalil')
};

const stage = {
    basename: '/',
    defaultPath: '/dashboard/default',
    fontFamily: `'Roboto', sans-serif`,
    borderRadius: 12,
    environment: readEnv('REACT_APP_ENVIRONMENT_LABEL', 'Pruebas'),
    baseResource: readEnv('REACT_APP_API_BASE_URL', 'https://test.api.rentascdmx.com'),
    authRedirectUri: readEnv('REACT_APP_AUTH_REDIRECT_URI', 'https://test.app.rentascdmx.com/'),
    companyName: readEnv('REACT_APP_COMPANY_NAME', 'Padilla&Bujalil')
};

const development = {
    basename: '/',
    defaultPath: '/dashboard/default',
    fontFamily: `'Roboto', sans-serif`,
    borderRadius: 12,
    environment: readEnv('REACT_APP_ENVIRONMENT_LABEL', 'Desarrollo'),
    baseResource: readEnv('REACT_APP_API_BASE_URL', 'http://localhost:10000/api'),
    authRedirectUri: readEnv('REACT_APP_AUTH_REDIRECT_URI', 'http://localhost:3000'),
    companyName: readEnv('REACT_APP_COMPANY_NAME', 'Pb')
};

const configs = {
    development,
    test: stage,
    stage,
    staging: stage,
    production,
    prod: production
};

const config = configs[env] || (process.env.NODE_ENV === 'development' ? development : production);

export default config;
